(function () {
  const root = document.documentElement;
  const body = document.body;
  if (root.getAttribute("lang") !== "en") root.setAttribute("dir", "rtl");
  if (!root.getAttribute("lang")) root.setAttribute("lang", "he");
  if (body) body.classList.add("zohar-gallery");

  const banned = [
    "OUR BAG",
    "INSPIRED BY THE 90S",
    "ELEGANT & TIMELESS",
    "SHOP NOW",
    "SALE",
    "במבצע"
  ];

  function hideBannedCopy(scope) {
    const nodes = (scope || document).querySelectorAll("h1, h2, h3, h4, p, span, a, button, .badge");
    nodes.forEach((el) => {
      if (el.closest("[data-zohar-announce], .zohar-announce, .zohar-cookie, #shopify-pc-root")) return;
      const text = (el.textContent || "").replace(/\s+/g, " ").trim().toUpperCase();
      if (!text) return;
      if (banned.some((b) => text === b || text.includes(b))) {
        const block = el.closest(".slideshow__slide, .hero, .banner, .badge, li, .announcement") || el;
        block.style.display = "none";
      }
    });
  }

  function disableAutoplay() {
    document.querySelectorAll("video[autoplay]").forEach((v) => {
      v.removeAttribute("autoplay");
      v.pause();
    });
    document.querySelectorAll("[data-autoplay]").forEach((el) => {
      if (el.hasAttribute("data-zohar-announce")) return;
      el.setAttribute("data-autoplay", "false");
      el.dataset.autoplay = "false";
    });
  }

  function rotateAnnounce() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    document.querySelectorAll("[data-zohar-announce]").forEach((bar) => {
      const lines = [...bar.querySelectorAll(".zohar-announce__line")];
      if (lines.length < 2) return;
      let i = Math.max(0, lines.findIndex((l) => l.classList.contains("is-active")));
      const interval = Number(bar.getAttribute("data-interval")) || 5000;
      let timer;
      const tick = () => {
        lines[i].classList.remove("is-active");
        i = (i + 1) % lines.length;
        lines[i].classList.add("is-active");
      };
      const play = () => {
        stop();
        timer = window.setInterval(tick, interval);
      };
      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };
      bar.addEventListener("mouseenter", stop);
      bar.addEventListener("mouseleave", play);
      bar.addEventListener("focusin", stop);
      bar.addEventListener("focusout", (event) => {
        if (!bar.contains(event.relatedTarget)) play();
      });
      play();
    });
  }

  function focusables(rootEl) {
    return [...rootEl.querySelectorAll("a[href], button:not([disabled]), textarea, input, select, summary, [tabindex]:not([tabindex='-1'])")].filter(
      (el) => !el.hasAttribute("hidden") && el.getAttribute("aria-hidden") !== "true"
    );
  }

  function setMenuExpanded(open) {
    document.querySelectorAll('[data-zohar-open="ZoharDrawer"]').forEach((btn) => {
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    setMenuExpanded(true);
    const panel = drawer.querySelector(".zohar-drawer__panel") || drawer;
    const items = focusables(panel);
    (items[0] || panel).focus();
  }

  function closeDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    setMenuExpanded(false);
    const opener = document.querySelector(`[data-zohar-open="${id}"]`);
    if (opener) opener.focus();
  }

  document.addEventListener("click", (event) => {
    const openBtn = event.target.closest("[data-zohar-open]");
    if (openBtn) {
      event.preventDefault();
      openDrawer(openBtn.getAttribute("data-zohar-open"));
    }
    const closeBtn = event.target.closest("[data-zohar-close]");
    if (closeBtn) {
      event.preventDefault();
      closeDrawer(closeBtn.getAttribute("data-zohar-close"));
    }
  });

  document.addEventListener("keydown", (event) => {
    const openDrawerEl = document.querySelector(".zohar-drawer.is-open");
    if (event.key === "Escape" && openDrawerEl) {
      closeDrawer(openDrawerEl.id);
      return;
    }
    if (event.key !== "Tab" || !openDrawerEl) return;
    const panel = openDrawerEl.querySelector(".zohar-drawer__panel") || openDrawerEl;
    const items = focusables(panel);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function reduceLogoOnScroll() {
    document.querySelectorAll(".zohar-header").forEach((header) => {
      const scroller = header.closest(".phone-scroll");
      const readY = () => (scroller ? scroller.scrollTop : window.scrollY || document.documentElement.scrollTop);
      const onScroll = () => header.classList.toggle("reduce-logo-size", readY() > 12);
      (scroller || window).addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    });
  }

  const CALENDLY = "https://calendly.com/shaizohar32/60";

  function enableAppointmentButtons() {
    document.querySelectorAll("a, button").forEach((el) => {
      if (el.closest("form[action*='contact']") || el.closest(".zohar-contact")) return;
      const text = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (text !== "קביעת פגישה" && text !== "לקביעת פגישה") return;
      el.removeAttribute("disabled");
      el.removeAttribute("aria-disabled");
      el.classList.remove("disabled");
      if (el.tagName === "A") {
        const href = el.getAttribute("href") || "";
        if (!href.includes("calendly.com")) el.setAttribute("href", CALENDLY);
      } else {
        el.addEventListener("click", (event) => {
          event.preventDefault();
          window.location.href = CALENDLY;
        });
      }
    });
  }

  const COOKIE_HE = {
    body: "אנחנו משתמשים בעוגיות כדי לשפר את האתר.",
    accept: "אישור",
    manage: "נהול"
  };

  function hebraizePrivacy(root) {
    if (!root) return;
    root.setAttribute("dir", "rtl");
    root.querySelectorAll("p, span, div, button, a, label").forEach((el) => {
      if (el.children.length > 1) return;
      const raw = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (!raw) return;
      if (/cookie/i.test(raw) && raw.length > 18) el.textContent = COOKIE_HE.body;
      else if (/^(accept|allow all|agree|allow)$/i.test(raw)) el.textContent = COOKIE_HE.accept;
      else if (/manage|preference/i.test(raw)) el.textContent = COOKIE_HE.manage;
    });
  }

  function initCookie() {
    const fallback = document.querySelector("[data-zohar-cookie]");
    const shopifyRoot = document.getElementById("shopify-pc-root");
    const hasPrivacyScript = Boolean(document.querySelector('script[src*="privacy-banner"]'));
    if (shopifyRoot || hasPrivacyScript) {
      if (fallback) fallback.hidden = true;
      if (shopifyRoot) hebraizePrivacy(shopifyRoot);
      const obs = new MutationObserver(() => hebraizePrivacy(document.getElementById("shopify-pc-root")));
      obs.observe(document.body, { childList: true, subtree: true });
      return;
    }
    if (!fallback) return;
    try {
      if (window.localStorage.getItem("zohar-cookie") === "ok") {
        fallback.hidden = true;
        return;
      }
    } catch (e) {
      /* ignore */
    }
    fallback.hidden = false;
    const accept = fallback.querySelector("[data-zohar-cookie-accept]");
    const manage = fallback.querySelector("[data-zohar-cookie-manage]");
    if (accept) {
      accept.addEventListener("click", () => {
        try {
          window.localStorage.setItem("zohar-cookie", "ok");
        } catch (e) {
          /* ignore */
        }
        fallback.hidden = true;
      });
    }
    if (manage) {
      manage.addEventListener("click", () => {
        if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.showPreferences) {
          Shopify.customerPrivacy.showPreferences();
          return;
        }
        window.location.href = "/pages/להשארת-פרטים";
      });
    }
  }

  hideBannedCopy(document);
  disableAutoplay();
  rotateAnnounce();
  reduceLogoOnScroll();
  enableAppointmentButtons();
  initCookie();
})();
